import request from '@/utils/axios'

// 用户收藏
export function userCollection (data) {
  return request({
    url: '/trade/optionsAdd',
    method: 'post',
    data: data
  })
}

// 取消收藏
export function cancelCollection (data) {
  return request({
    url: '/trade/optionsDelete',
    method: 'post',
    data: data
  })
}

// 获取用户收藏列表
export function userCollectList () {
  return request({
    url: '/trade/optionsList',
    method: 'post'
  })
}

